import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

const useWrapper = (handler, props, dependencies = []) => useCallback(() => handler(props), dependencies);

const useRefreshByCategory = (type, category) => {
  const handler = useDispatch();
  return useCallback(({ page }) => handler({ type, category, page }), [category]);
};

const useRefreshByCode = (type, category, code) => {
  const handler = useDispatch();
  return useCallback(({ page }) => handler({
    type, category, code, page,
  }), [category, code]);
};

const useFetch = (type) => {
  const handler = useDispatch();
  return useCallback(({ append, page, pageSize }) => handler({
    type, append, page, pageSize,
  }), []);
};

const useFetchByCategory = (type, category) => {
  const handler = useDispatch();
  return useCallback(({ append, page, pageSize }) => handler({
    type, category, append, page, pageSize,
  }), [category]);
};

const useFetchByCode = (type, category, code) => {
  const handler = useDispatch();
  return useCallback(({ append, page, pageSize }) => handler({
    type, category, code, append, page, pageSize,
  }), [category, code]);
};

export default {
  useDispatchByCategory: (type, category) => useWrapper(useDispatch(), { type, category }, [category]),
  useDispatchByCode: (type, category, code) => useWrapper(useDispatch(), { type, category, code }, [category, code]),
  useFetch,
  useFetchByCategory,
  useFetchByCode,
  useRefreshByCategory,
  useRefreshByCode,
  useSimpleDispatch: (type) => useWrapper(useDispatch(), { type }, []),
};
